import { _ as _call_super } from "@swc/helpers/_/_call_super";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _wrap_native_super } from "@swc/helpers/_/_wrap_native_super";
import { IApiError } from "@faire/web-api--source/indigofair/data/IApiError";
// Error class abstraction that enables framework agnostic error handling
export var WebApiError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(WebApiError, Error1);
    function WebApiError(message, httpStatusCode, responseData) {
        _class_call_check(this, WebApiError);
        var _this;
        _this = _call_super(this, WebApiError, [
            message
        ]), _this.name = "WebApiError";
        _this.httpStatusCode = httpStatusCode;
        _this.responseData = IApiError.build(responseData);
        return _this;
    }
    return WebApiError;
}(_wrap_native_super(Error));
